// removed by extract-text-webpack-plugin
module.exports = {"answerList":"answerList__22bAt","answerListEmpty":"answerListEmpty__1J1o5","answerListLoading":"answerListLoading__3Tb3s"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/AnswerList/index.css
// module id = 1506
// module chunks = 0